import type { ReactNode } from 'react';

interface PageHeadProps {
  title: string;
  subtitle?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
  eyebrow?: ReactNode;
  children?: ReactNode;
}

export function PageHead({
  title,
  subtitle,
  filters,
  actions,
  eyebrow,
  children,
}: PageHeadProps): JSX.Element {
  return (
    <header className="app-pagehead" data-screen-label={title}>
      <div className="app-pagehead__top">
        <div className="app-pagehead__title-block">
          {eyebrow !== undefined && <div className="app-pagehead__eyebrow">{eyebrow}</div>}
          <h1 className="app-pagehead__title">{title}</h1>
          {subtitle !== undefined && <div className="app-pagehead__subtitle">{subtitle}</div>}
        </div>
        {actions !== undefined && <div className="app-pagehead__actions">{actions}</div>}
      </div>
      {filters !== undefined && <div className="app-pagehead__filters">{filters}</div>}
      {children}
    </header>
  );
}
